import { render, staticRenderFns } from "./ChemicalAgentsResearched.vue?vue&type=template&id=66042487&scoped=true&"
import script from "./ChemicalAgentsResearched.vue?vue&type=script&lang=js&"
export * from "./ChemicalAgentsResearched.vue?vue&type=script&lang=js&"
import style0 from "./ChemicalAgentsResearched.vue?vue&type=style&index=0&id=66042487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66042487",
  null
  
)

export default component.exports